module.exports = __webpack_public_path__ + "1274ee1e138aef3c282703e0db678b6a.svg";